// extracted by mini-css-extract-plugin
export var content = "BaseDescription-module--content--nH1eY";
export var column_description = "BaseDescription-module--column_description--FFSKR";
export var buttons = "BaseDescription-module--buttons--PyX4y";
export var logoBlock_title = "BaseDescription-module--logoBlock_title--Xk5Bz";